// https://docs.google.com/spreadsheets/d/1j0Q_f7L6njrTdExqD6-h0HK4_xJ1kGzyTikv861DzAA/edit#gid=0
const pearConfigId = {
  PEAR_ID: '10000001666',
  TYPE_PEAR_ID: '10000001699',
};
export default pearConfigId;
